export default __webpack_public_path__ + "static/media/paprika_jancsi_etterem_05.d8130f97.JPG";